import React from 'react'
import carleton_pathwaysimg from "./image.png";


export default function Logo() {
  return (
    <img src={carleton_pathwaysimg} alt="alt" />
)
}
